import {
  useMutation
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  AcceptDirectSaleNegotiationBodyDto,
  AcceptDirectSaleNegotiationResponseDto,
  BackendErrorEntity
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiAcceptDirectSaleNegotiation = (
    directSaleId: MaybeRef<string | undefined | null>,
    acceptDirectSaleNegotiationBodyDto: MaybeRef<AcceptDirectSaleNegotiationBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
acceptDirectSaleNegotiationBodyDto = unref(acceptDirectSaleNegotiationBodyDto);
      
      return fetchApiInstance<AcceptDirectSaleNegotiationResponseDto>(
      {url: `/directSaleNegotiations/${directSaleId}/accept`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: acceptDirectSaleNegotiationBodyDto
    },
      options);
    }
  


export const getApiAcceptDirectSaleNegotiationMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAcceptDirectSaleNegotiation>>, TError,{directSaleId: string;data: BodyType<AcceptDirectSaleNegotiationBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAcceptDirectSaleNegotiation>>, TError,{directSaleId: string;data: BodyType<AcceptDirectSaleNegotiationBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAcceptDirectSaleNegotiation>>, {directSaleId: string;data: BodyType<AcceptDirectSaleNegotiationBodyDto>}> = (props) => {
          const {directSaleId,data} = props ?? {};

          return  apiAcceptDirectSaleNegotiation(directSaleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAcceptDirectSaleNegotiationMutationResult = NonNullable<Awaited<ReturnType<typeof apiAcceptDirectSaleNegotiation>>>
    export type ApiAcceptDirectSaleNegotiationMutationBody = BodyType<AcceptDirectSaleNegotiationBodyDto>
    export type ApiAcceptDirectSaleNegotiationMutationError = ErrorType<BackendErrorEntity>

    export const useApiAcceptDirectSaleNegotiation = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAcceptDirectSaleNegotiation>>, TError,{directSaleId: string;data: BodyType<AcceptDirectSaleNegotiationBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiAcceptDirectSaleNegotiation>>,
        TError,
        {directSaleId: string;data: BodyType<AcceptDirectSaleNegotiationBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiAcceptDirectSaleNegotiationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    